import * as React from 'react';

const SvgNavIntegrations = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "m17.47 3-1.26-1.5H7.79L6.53 3H2v2h5.47l1.25-1.5h6.56L16.53 5H20v14H4V7H2v14h20V3h-4.53Zm-1.64 12 2.52-3-2.52-3h-2.61l2.52 3-2.52 3h2.61ZM8.17 9l-2.52 3 2.52 3h2.61l-2.52-3 2.52-3H8.17Z" })
);

export { SvgNavIntegrations as default };
//# sourceMappingURL=NavIntegrations.es.js.map
